import { formatarDigitacaoMoeda } from '../lib/moeda'

// O campo de digitar dinheiro do app inteiro. Nove lugares usam este mesmo.
//
// ⚠ POR QUE UM COMPONENTE, e nao um `type="number"` em cada tela:
//
// 1. `<input type="number">` ENGOLE o ponto de milhar. Medido em 16/08/2026 com
//    locale pt-BR: digitar "1.234,56" deixa o campo com "1.23456", ou seja
//    R$ 1,23 -- sem erro, sem aviso. Valor errado gravado, e a pessoa nao tem
//    como perceber. Por isso aqui e `type="text"` com `inputMode="decimal"`,
//    que abre o teclado numerico no celular sem filtrar o que foi digitado.
// 2. O cifrao fica FORA do input, como enfeite fixo. Dentro do valor ele vira
//    caractere que a pessoa apaga sem querer e que a conversao tem de limpar.
// 3. Ao SAIR do campo o texto e reescrito no formato brasileiro. E o que faz a
//    pessoa VER o que gravou -- e, quando o app entende diferente do que ela
//    quis, o erro aparece na hora em vez de sair meses depois numa comissao.
//
// Achado dela no smoke do beta: "os campos que recebem valores nao estao
// configurados para valores em reais isso esta confundindo o representante na
// digitacao".

interface Props {
  value: string
  onChange: (texto: string) => void
  /** Chamado depois de o texto ja ter sido formatado. */
  onBlur?: () => void
  id?: string
  'aria-label'?: string
  'data-testid'?: string
  placeholder?: string
  /** Classes da CAIXA (borda, largura, alinhamento). O input herda. */
  className?: string
  disabled?: boolean
}

export default function CampoMoeda({
  value, onChange, onBlur, id, placeholder, className = '', disabled,
  'aria-label': ariaLabel, 'data-testid': testId,
}: Props) {
  return (
    // A borda mora na CAIXA, e nao no input: e assim que o "R$" fica dentro do
    // retangulo sem sobrepor o texto digitado nem depender de padding chutado.
    <div className={`flex items-center gap-1 ${className}`}>
      <span className="text-slate-500 shrink-0 select-none" aria-hidden="true">R$</span>
      <input
        id={id}
        aria-label={ariaLabel}
        data-testid={testId}
        type="text"
        inputMode="decimal"
        placeholder={placeholder ?? '0,00'}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => {
          // Formata ANTES de avisar o pai: telas que gravam no onBlur
          // (EdicaoTabelaPreco) leem o texto, e as duas formas convertem para o
          // mesmo numero -- mas o que fica na tela tem de ser o formatado.
          const formatado = formatarDigitacaoMoeda(value)
          if (formatado !== value) onChange(formatado)
          onBlur?.()
        }}
        // `w-full min-w-0` deixa o input encolher dentro do flex; sem min-w-0
        // ele se recusa a encolher e estoura a caixa em tela estreita.
        className="w-full min-w-0 bg-transparent outline-none [color:inherit]"
      />
    </div>
  )
}
